import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      title: 'Register Flight Details',
      description: 'Adult children register their parents\' flight info. Helpers register flights where they can assist.',
      icon: '📝'
    },
    {
      number: '2',
      title: 'Get Matched Instantly',
      description: 'Our system matches helpers and travelers on the SAME FLIGHT. See profiles, ratings, and languages spoken.',
      icon: '🤝'
    },
    {
    number: '3',
    title: 'Connect & Confirm',
    description: 'Choose your helper and confirm the arrangement. Contact details are revealed to both parties securely.',
    icon: '💳'
    },
    {
      number: '4',
      title: 'Meet at Airport',
      description: 'Helper assists with check-in, security, navigation, and boarding. Verify with unique code.',
      icon: '✈️'
    }
  ];

  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            How Same Flight Friends Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Simple, safe, and reliable airport assistance in 4 easy steps
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col md:flex-row gap-6 mb-12 last:mb-0">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg">
                  {step.number}
                </div>
              </div>
              <div className="flex-1 bg-gray-50 p-6 rounded-xl border border-gray-200">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-4xl">{step.icon}</span>
                  <h3 className="text-2xl font-bold text-gray-900">
                    {step.title}
                  </h3>
                </div>
                <p className="text-gray-600 text-lg leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 bg-green-50 text-green-800 px-6 py-3 rounded-full border border-green-200">
            <span className="text-2xl">✓</span>
            <span className="font-semibold">Same flight = Maximum trust and convenience</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;